import { Search, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

export function MobileHeaderSearch({ value, onChange, onClose, onClear, placeholder }) {
    const { t } = useTranslation();
    const handleClear = () => {
        onChange('');
        onClear?.();
    };

    return (
        <div className="mobile-only md:hidden bg-background border-b border-border shadow-sm sticky top-0 z-40">
            <div className="px-[20px] py-[16px] flex items-center gap-[16px]">
                <div className="flex-1 relative">
                    <Search className="absolute left-[16px] top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground pointer-events-none" />
                    <input
                        type="text"
                        placeholder={placeholder ?? t('common:rechercherUnRapportUnDossierOuUnePhoto')}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        autoFocus
                        className="w-full bg-card border border-border rounded-[8px] pl-[48px] pr-[40px] py-[10px] text-[13px] text-foreground placeholder:text-muted-foreground outline-none focus:border-secondary transition-colors font-light"
                    />
                    {value && (
                        <Button
                            variant="plain"
                            color="neutral"
                            size="auto"
                            type="button"
                            onClick={handleClear}
                            className="absolute right-[12px] top-1/2 -translate-y-1/2 h-5 w-5 rounded-full bg-border hover:bg-muted-foreground/30 flex items-center justify-center transition-colors"
                        >
                            <X className="h-3 w-3 text-muted-foreground" />
                        </Button>
                    )}
                </div>
                <Button
                    variant="plain"
                    color="neutral"
                    size="auto"
                    onClick={onClose}
                    className="flex items-center justify-center h-[42px] w-[42px] rounded-[8px] bg-muted hover:bg-border transition-colors shrink-0"
                >
                    <X className="h-5 w-5 text-muted-foreground" />
                </Button>
            </div>
        </div>
    );
}
